import React from 'react';
import Alert, { AlertContent, AlertProps, AlertTitle } from './Alert';
import createNotificationCenter, { RenderCallbacks } from './createNotificationCenter';
import Button from '../Button';

type TitleOrDescription = { title: string } | { description: string };

type Notification = TitleOrDescription & {
  actionButtons?: Array<
    React.ReactElement<
      Omit<any, 'onClick'> & {
        onClick: (e: Event, callbacks: RenderCallbacks<Notification>) => void;
      },
      typeof Button
    >
  >;
  alertProps?: Partial<AlertProps>;
  closable?: boolean;
  description?: string;
  title?: string;
};

function renderNotification(
  notification: Notification,
  { removeNotification }: RenderCallbacks<Notification>
): React.ReactNode {
  const { alertProps = {}, closable, description, title } = notification;

  const onClose = alertProps.onClose;

  if (closable || (closable !== false && typeof onClose !== 'undefined')) {
    alertProps.onClose = (e): void => {
      removeNotification();

      if (typeof onClose !== 'undefined') {
        onClose(e);
      }
    };
  }

  return (
    <Alert {...alertProps}>
      {title && <AlertTitle>{title}</AlertTitle>}
      {description && <AlertContent>{description}</AlertContent>}
    </Alert>
  );
}

const { NotificationCenterProvider, NotificationCenter, useNotifier } = createNotificationCenter(renderNotification);

export { NotificationCenterProvider, useNotifier };
export default NotificationCenter;
